var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"transform":"translate(-41.521996,-44.372993)"}},[_c('ellipse',{attrs:{"ry":"97.359001","rx":"100.21","cy":"141.73199","cx":"141.73199","fill":_vm.getButtonColor ? _vm.getButtonColor : '#ffffff'}}),_c('polygon',{attrs:{"points":"124.672,122.594 158.793,141.732 124.672,160.872 ","fill":_vm.getButtonColor ? '#fff' : '#ef4e5e'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }